import {
  ChartBarIcon,
  HomeIcon,
  KeyIcon,
  QueueListIcon,
  ServerStackIcon,
  ShieldCheckIcon,
  SparklesIcon,
  TicketIcon,
  UsersIcon,
} from '@heroicons/vue/24/outline'
import type { NavGroup } from '@/types/navigation.types'

/**
 * Sidebar navigation config.
 * Labels are i18n keys resolved at render time via $t().
 * Groups are separated by dividers in the sidebar.
 * Visibility is controlled by the `roles` array on each item/group.
 *
 * Add domain-entity items here as you build them — see
 * docs/guides/adding-entities.md → "Register in Sidebar Navigation".
 */
export const navigationGroups: NavGroup[] = [
  {
    id: 'main',
    access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
    items: [
      {
        routeName: 'dashboard',
        label: 'nav.home',
        icon: HomeIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
    ],
  },
  {
    id: 'dashboards',
    access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
    items: [
      {
        routeName: 'dashboards',
        label: 'nav.dashboards',
        icon: ChartBarIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
      {
        routeName: 'ai-dashboards',
        label: 'nav.ai_dashboards',
        icon: SparklesIcon,
        access_levels: ['access_level.admin'],
      },
      {
        // NB: this list is NOT derived from the route's `meta.access_levels`
        // — keep the two in sync by hand (see router/index.ts).
        routeName: 'code-quality',
        label: 'nav.code_quality',
        icon: ShieldCheckIcon,
        access_levels: ['access_level.admin', 'access_level.manager', 'access_level.user'],
      },
    ],
  },
  {
    id: 'machine-auth',
    label: 'nav.group_authentication',
    access_levels: ['access_level.admin'],
    items: [
      {
        routeName: 'application-list',
        label: 'nav.applications',
        icon: ServerStackIcon,
        access_levels: ['access_level.admin'],
      },
      {
        routeName: 'signing-key-list',
        label: 'nav.signing_keys',
        icon: KeyIcon,
        access_levels: ['access_level.admin'],
      },
      {
        routeName: 'token-list',
        label: 'nav.tokens',
        icon: TicketIcon,
        access_levels: ['access_level.admin'],
      },
    ],
  },
  {
    id: 'configuration',
    label: 'nav.configuration',
    access_levels: ['access_level.admin', 'access_level.manager'],
    items: [
      {
        routeName: 'employee-list',
        label: 'nav.configuration_staff',
        icon: UsersIcon,
        access_levels: ['access_level.admin', 'access_level.manager'],
      },
      {
        routeName: 'issue-squad-query-list',
        label: 'nav.configuration_issue_queries',
        icon: QueueListIcon,
        access_levels: ['access_level.admin', 'access_level.manager'],
      },
    ],
  },
]
